import React from 'react';
import classNames from 'classnames';
import css from './ReviewRatingCustom.module.css';

const STAR_COLORS = {
  default: {
    fill: '#B95995',
    stroke: '#920075',
    emptyStroke: '#999999',
    emptyFill: 'none',
    halfEmptyFill: '#F2F2F2',
  },
  white: {
    fill: '#F8F8F8',
    stroke: '#F8F8F8',
    emptyStroke: '#F8F8F8',
    emptyFill: 'none',
    halfEmptyFill: '#B95995',
  },
};

export const StarEmpty = ({ colors }) => (
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none">
    <path
      d="M7.6875 3.1377L11.0059 4.27637L9.03809 7.00293L8.98047 10.5107L5.70312 9.45703L2.4248 10.5107L2.36816 7.00293L0.399414 4.27637L3.71875 3.1377L5.70312 0.423828Z"
      fill={colors.emptyFill}
      stroke={colors.emptyStroke}
      strokeWidth="0.5"
    />
  </svg>
);

export const StarFull = ({ colors }) => (
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none">
    <path
      d="M7.6875 3.1377L11.0059 4.27637L9.03809 7.00293L8.98047 10.5107L5.70312 9.45703L2.4248 10.5107L2.36816 7.00293L0.399414 4.27637L3.71875 3.1377L5.70312 0.423828Z"
      fill={colors.fill}
      stroke={colors.stroke}
      strokeWidth="0.5"
    />
  </svg>
);

export const StarHalf = ({ colors, id }) => (
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none">
    <path
      d="M7.98438 3.1377L11.3027 4.27637L9.33496 7.00293L9.27734 10.5107L6 9.45703L2.72168 10.5107L2.66504 7.00293L0.696289 4.27637L4.01562 3.1377L6 0.423828Z"
      fill={colors.fill}
      stroke={colors.stroke}
      strokeWidth="0.5"
    />
    <g clipPath={`url(#clip-half-${id})`}>
      <path
        d="M7.98438 3.1377L11.3027 4.27637L9.33496 7.00293L9.27734 10.5107L6 9.45703L2.72168 10.5107L2.66504 7.00293L0.696289 4.27637L4.01562 3.1377L6 0.423828Z"
        fill={colors.halfEmptyFill}
        stroke={colors.emptyStroke}
        strokeWidth="0.5"
      />
    </g>

    <defs>
      <clipPath id={`clip-half-${id}`}>
        <rect width="6" height="11" transform="translate(6)" />
      </clipPath>
    </defs>
  </svg>
);


/**
 * @param {Object} props
 * @param {number} props.rating
 * @param {'default'|'white'} [props.variant]
 * @param {string} [props.className]
 */
const ReviewRatingCustom = props => {
  const { rating, variant = 'default', className } = props;

  const classes = classNames(css.root, className);
  const colors = STAR_COLORS[variant];

  const stars = [];

  for (let i = 1; i <= 5; i++) {
    if (rating >= i) {
      stars.push(<StarFull key={i} colors={colors} />);
    } else if (rating >= i - 0.5) {
      stars.push(<StarHalf key={i} id={i} colors={colors} />);
    } else {
      stars.push(<StarEmpty key={i} colors={colors} />);
    }
  }

  return <div className={classes}>{stars}</div>;
};

export default ReviewRatingCustom;